import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { LogIn, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import "@/App.css";
import "@/login.css";

const MESSAGES = { 429: "Too many failed attempts. Please try again in a few minutes." };

export function RequireAuth({ children }) {
  const [state, setState] = useState("checking");
  useEffect(() => {
    let alive = true;
    api.me().then(() => alive && setState("in"), () => alive && setState("out"));
    return () => { alive = false; };
  }, []);
  if (state === "checking") return <div className="app-shell" />;
  return state === "in" ? children : <Navigate to="/login" replace />;
}

export function Login() {
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [signedIn, setSignedIn] = useState(false);

  useEffect(() => { api.me().then(() => setSignedIn(true), () => {}); }, []);
  if (signedIn) return <Navigate to="/" replace />;

  const submit = async e => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      await api.login(identifier.trim(), password);
      navigate("/", { replace: true });
    } catch (err) {
      const status = err?.response?.status;
      setError(MESSAGES[status] || (status === 401 || status === 422 ? "Invalid username/email or password." : "Unable to sign in right now. Please try again."));
      setPassword("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="app-shell login-shell">
      <form className="login-card sheet-form" data-testid="login-form" onSubmit={submit} noValidate>
        <div className="brand login-brand">
          <div className="brand-mark"><Sparkles size={17} /></div>
          <div><strong>GInfomedia AI</strong><span>QUERY HUB</span></div>
        </div>
        <div>
          <h1 className="login-title">Sign in</h1>
          <p className="login-sub">Use your workspace account to continue.</p>
        </div>
        {error && <div className="unavailable-note login-error" role="alert" data-testid="login-error">{error}</div>}
        <label>Username or email
          <input type="text" autoComplete="username" autoFocus required maxLength={254} value={identifier} data-testid="login-identifier" onChange={e => setIdentifier(e.target.value)} />
        </label>
        <label>Password
          <input type="password" autoComplete="current-password" required maxLength={72} value={password} data-testid="login-password" onChange={e => setPassword(e.target.value)} />
        </label>
        <button className="save-btn" type="submit" data-testid="login-button" disabled={busy || !identifier.trim() || !password}><LogIn size={16} /> {busy ? "Signing in…" : "Login"}</button>
      </form>
    </div>
  );
}
